import { render, staticRenderFns } from "./SettingsAdd.vue?vue&type=template&id=3b3e139c&scoped=true&"
import script from "./SettingsAdd.vue?vue&type=script&lang=js&"
export * from "./SettingsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAdd.vue?vue&type=style&index=0&id=3b3e139c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e139c",
  null
  
)

export default component.exports